export { default } from './search.routes';
